module.exports = __webpack_public_path__ + "static/img/tc03.1f9fd9a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/aug_activity/tc03.png
// module id = 1518
// module chunks = 215